<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <h4 style="padding-bottom: 20px">Введите ваш код в форму и переходите к подбору картины</h4>
            <div class="row">
                <div class="col-sm-6 mb-2">
                    <div class="input-group">
                        <span class="input-group-text" id="codeInput">Ваш код</span>
                        <input v-model="qr_code" :class="{'is-invalid' : is_invalid}" type="text" class="form-control"
                               placeholder="Код из набора"
                               aria-label="Код из набора" aria-describedby="codeInput">
                        <div id="codeInputFeedback" class="invalid-feedback text-end">
                            Не верный код, попробуйте еще раз.
                        </div>
                    </div>

                </div>
                <div class="d-grid gap-2  col-sm-6 mb-2 mx-auto">
                    <button @click="check_code" class="btn btn-outline-secondary" type="button">Перейти к подбору
                        картины
                    </button>
                </div>
            </div>
            <div style="padding: 20px 5px 20px 5px;">
                <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Где взять код из набора ?
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                На обратной стороне холста размещен QR-код, перейдите по нему.
                                Вы можете перейти к генерации картины сразу на открытой странице или скопировать код и
                                воспользоваться им на другом устройстве.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                            <button @click="counter += 1" class="accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Сколько раз можно активировать код ?
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Вы можете подбирать картину сколько угодно раз, до того момента,
                                пока результат вам не понравится.
                                Но вы сможете получить инструкцию только на одну картину, которую выберете.
                                Мы понимаем что вы можете передумать, поэтому изменить картину вы сможете только написав
                                нам в поддержку.
                                Так же вы должны понимать, что если вы уже начали рисовать картину, то нет смысла
                                изменять инструкцию.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Что делать если код неверен ?
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Напишите нам в поддержку и мы постараемся вам помочь. Не забудьте прикрепить фотографии
                                вашего набора, четкую фотографию QR-кода и описание проблемы.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="pl" v-if="show_spinner">
            <grid-loader class="sp" :loading="true" color="blue"></grid-loader>
        </div>
    </div>
</template>

<script>
    import GridLoader from 'vue-spinner/src/GridLoader.vue'

    export default {
        name: "QrCodeN",
        components: {
            GridLoader
        },
        data() {
            return {
                qr_code: null,
                show_spinner: false,
                is_invalid: false
            }
        },
        methods: {
            async check_code() {
                try {
                    this.is_invalid = false;
                    this.show_spinner = true;
                    const response = await
                        this.$axios.post('/qr_code_check',
                            {
                                qr_code: this.qr_code,
                            });

                    let res_check = response.data.res_check;
                    if (res_check === 'error') {
                        this.is_invalid = true;
                    } else if (res_check === 'ok') {
                        this.$router.push('/generation/' + this.qr_code);
                    } else if (res_check === 'pdf') {
                        this.$router.push('/instruction/' + this.qr_code);
                    }

                    this.show_spinner = false;
                } catch (e) {
                    console.log(e);
                    this.show_spinner = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>